// import React, { Suspense } from "react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
// import ReactDOM from "react-dom/client";
// import myLogo from "./assets/images/logo.png";
// import * as serviceWorkerRegistration from "./service-worker";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./index.css";
// import Spinner from "./components/spinner/Spinner";

// const root = ReactDOM.createRoot(document.getElementById("root"));
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    {/* <Suspense fallback={<Spinner />}> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </Suspense> */}
  </React.StrictMode>
);

// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     const confirmationMessage = `New update is available. Click OK to reload.`;
//     if (window.confirm(confirmationMessage)) {
//       registration.waiting.postMessage({ type: "SKIP_WAITING" });
//     }
//   },
// });

// reportWebVitals();
